import $ from "jquery";

$('.searchsca-homepage__form-sca input').on('change', function (e) {
  var target = $(this).val();
  var vcu_search = {
    placeholder: 'Search rare books, periodicals, digital images, and more',
    labelText: 'VCU Libraries collections',
    type: 'quicksearch'
  };
  var archivesspace = {
    placeholder: 'Search finding aids',
    labelText: 'Finding Aids',
    type: 'archivesspace'
  };
  var comics = {
    placeholder: 'Search comics collection',
    labelText: 'Comics collection',
    type: 'comics'
  };

   if (target === 'primo') {
    $(document.getElementById("search").style.backgroundColor = "#F8B300");
    $('form.searchsca-homepage__form-sca label').attr('placeholder', vcu_search.type);
    $('form.searchsca-homepage__form-sca input').attr('placeholder', vcu_search.placeholder);
  }
  if (target === 'archivesspace') {
    $(document.getElementById("search").style.backgroundColor = "#B2E0D6");
    $('form.searchsca-homepage__form-sca label').attr('placeholder', vcu_search.type);
    $('form.searchsca-homepage__form-sca input').attr('placeholder', archivesspace.placeholder);
  }
  if (target === 'comics') {
    $(document.getElementById("search").style.backgroundColor = "#E57200");
    $('form.searchsca-homepage__form-sca label').attr('placeholder', vcu_search.type);
    $('form.searchsca-homepage__form-sca input').attr('placeholder', comics.placeholder);
  }
  $('form.searchsca-homepage__form-sca input[type=text]').focus();
});
